import React from 'react'
import { enumHLSearchDataType } from '../../VisualunitHelpers'
import { FoundationsConstants } from '../../FoundationsConstants'
import replaceFilterValueParameter_HLCount from './replaceFilterValueParameter_HLCount'
import replaceFilterValueParameter_HLAge from './replaceFilterValueParameter_HLAge'
import replaceFilterValueParameter_HLMoney from './replaceFilterValueParameter_HLMoney'
import replaceFilterValueParameter_HLDecimal from './replaceFilterValueParameter_HLDecimal'
import replaceFilterValueParameter_HLText from './replaceFilterValueParameter_HLText'
import replaceFilterValueParameter_HLDuration from './replaceFilterValueParameter_HLDuration'
import replaceFilterValueParameter_HLNumber from './replaceFilterValueParameter_HLNumber'
import replaceFilterValueParameter_HLDate from './replaceFilterValueParameter_HLDate'
import { useEditAppDimensionRowsMutation } from '../../Redux/Admin_Tasks/DimensionSlice/ManageDimensionSLice'
import { TGetFilterVal } from './GenericFilters'
import { IBusinessParamsOptions } from '../Reports/VisualUnitParamsDialog'

const replaceFilterValueParameter = (
    filterValue: any,
    listItemId: any,
    isBusinessParameterReplace: 0 | 1,
    bpdropDownOptions: IBusinessParamsOptions[],
    currentHLDataType: any,
    filterableId: any,
    filterValueListId: any,
    GetFilterValues: (filterValArgs: TGetFilterVal) => void,
    selectedItem: any,
    selectedParameters: any,
    MetadataId: number
): string | null | JSX.Element => {
    let replacedStr = filterValue

        switch (currentHLDataType) {
            case FoundationsConstants.HLDATATYPE.HLAge:
                try{
                return replaceFilterValueParameter_HLAge(
                    replacedStr,
                    listItemId,
                    filterableId,
                    filterValueListId,
                    filterValue,
                    GetFilterValues,
                    selectedItem,
                    selectedParameters,
                    MetadataId
                )
            }catch (e) {
                console.error('Console Error in replaceFilterValueParameter_HLAge:', e)
            }
        
            case FoundationsConstants.HLDATATYPE.HLCount:
                try{
                return replaceFilterValueParameter_HLCount( //BusinessParameter
                    replacedStr,
                    listItemId,
                    isBusinessParameterReplace,
                    bpdropDownOptions,
                    filterableId,
                    filterValueListId,
                    filterValue,
                    GetFilterValues,
                    selectedItem,
                    selectedParameters,
                    MetadataId
                )
            }catch (e) {
                console.error('Console Error in replaceFilterValueParameter_HLCount:', e)
            }
            case FoundationsConstants.HLDATATYPE.HLDate:
                try{
                return replaceFilterValueParameter_HLDate(
                    replacedStr,
                    listItemId,
                    filterableId,
                    filterValueListId,
                    filterValue,
                    GetFilterValues,
                    selectedItem,
                    selectedParameters,
                    MetadataId
                )
            }catch (e) {
                console.error('Console Error in replaceFilterValueParameter_HLDate:', e)
            }
            case FoundationsConstants.HLDATATYPE.HLDuration:
                try{
                return replaceFilterValueParameter_HLDuration( //BusinessParameter
                    replacedStr,
                    listItemId,
                    isBusinessParameterReplace,
                    bpdropDownOptions,
                    filterableId,
                    filterValueListId,
                    filterValue,
                    GetFilterValues,
                    selectedItem,
                    selectedParameters,
                    MetadataId
                )
            }catch (e) {
                console.error('Console Error in replaceFilterValueParameter_HLDuration:', e)
            }
            case FoundationsConstants.HLDATATYPE.HLMoney:
                try{
                return replaceFilterValueParameter_HLMoney( //BusinessParameter
                    replacedStr,
                    listItemId,
                    isBusinessParameterReplace,
                    bpdropDownOptions,
                    filterableId,
                    filterValueListId,
                    filterValue,
                    GetFilterValues,
                    selectedItem,
                    selectedParameters,
                    MetadataId
                )
            }catch (e) {
                console.error('Console Error in replaceFilterValueParameter_HLMoney:', e)
            }
            case FoundationsConstants.HLDATATYPE.HLNumber:
                try{
                return replaceFilterValueParameter_HLNumber( //BusinessParameter
                    replacedStr,
                    listItemId,
                    isBusinessParameterReplace,
                    bpdropDownOptions,
                    filterableId,
                    filterValueListId,
                    filterValue,
                    GetFilterValues,
                    selectedItem,
                    selectedParameters,
                    MetadataId
                )
            }catch (e) {
                console.error('Console Error in replaceFilterValueParameter_HLNumber:', e)
            }
            case FoundationsConstants.HLDATATYPE.HLDecimal:
                try{
                return replaceFilterValueParameter_HLDecimal( //inprogress
                    replacedStr,
                    listItemId,
                    filterableId,
                    filterValueListId,
                    filterValue,
                    GetFilterValues,
                    selectedItem,
                    selectedParameters,
                    MetadataId
                )
            }catch (e) {
                console.error('Console Error in replaceFilterValueParameter_HLAge:', e)
            }
            case FoundationsConstants.HLDATATYPE.HLText:
                try{
                return replaceFilterValueParameter_HLText( //done
                    replacedStr,
                    listItemId,
                    filterableId,
                    filterValueListId,
                    filterValue,
                    GetFilterValues,
                    selectedItem,
                    selectedParameters,
                    MetadataId
                )
            }catch (e) {
                console.error('Console Error in FoundationsConstants.HLDATATYPE.HLText:', e)
            }
                break
            default:
                //FP-11206 Business prameter handled in respective component, in case need to catch error
                console.error("ReplaceFilterValueParams=> Out of currentHLDataType")
        }
    return null
}

export default replaceFilterValueParameter
